import React from 'react'
import styled from 'styled-components';
import { useTheme } from '../../middleware/ThemeContext';
import StyledText from '../../components/StyledComponents/StyledText';
import mockUpImg from '../../assets/images/mockup.png';
import backgroundImage from '../../assets/images/Content_bg.png';
import { Button } from '../../components/form/Button';
import IconBox from './IconBox';
import IconWidgetCircle from '../../assets/icons/IconWidgetCircle';
import IconMaximize from '../../assets/icons/IconMaximize';
import IconPaint from '../../assets/icons/IconPaint';
import IconSendSquare from '../../assets/icons/IconSendSquare';
import { useNavigate } from 'react-router-dom';
import { CorporateTheme } from '../../utils/themes';
import { apiSlice } from '../../services/apiSlice';
import { useAppDispatch } from '../../app/hooks';

const BuilderLandingPage = () => {
    const { theme } = useTheme();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    React.useEffect(() => {
        localStorage.removeItem('activeTabId');
    }, []);

    const handleCreateNewWebsite = () => {
        dispatch(apiSlice.util.resetApiState());
        navigate('/home/web-builder-default', { state: { showConfigPopup: true } });
    };

    return (
        <>
            <MainContent theme={theme}>
                <div style={{ width: '854px', margin: '0 auto', padding: '45px 0px' }}>
                    <SectionTop>
                        <img src={mockUpImg} alt={'MemberThings Website Builder'} style={{ width: '285px', height: 'auto' }} />
                        <div className='blurr-con'></div>
                        <div className='bgImage'>
                            <StyledText
                                htmlTag={'h1'}
                                fontSize='18px'
                                fontWeight={700}
                                textColor={CorporateTheme.colors.primary}
                                style={{ marginBottom: '10px' }}
                            >
                                MemberThings Website Builder
                            </StyledText>
                            <StyledText
                                htmlTag={'p'}
                                fontSize='14px'
                                fontWeight={400}
                                textColor={CorporateTheme.colors.textSecondary}
                                style={{ width: '55%', margin: '0 auto', lineHeight: '20px' }}
                            >
                                Create stunning, professional websites without any coding knowledge. Build pages with our drag-and-drop interface in minutes.
                            </StyledText>
                        </div>
                    </SectionTop>

                    <SectionProcess style={{ backgroundColor: theme.CorporateTheme.colors.lightOrangeBG, borderColor: theme.CorporateTheme.colors.borderOrange }}>
                        <div className='flow d-flex align-items-center justify-content-between position-relative' style={{ width: '80%', margin: '0 auto', marginBottom: '35px' }}>
                            <HorizontalLine style={{ backgroundColor: theme.CorporateTheme.colors.borderOrange }} />
                            <IconBox
                                icon={<IconWidgetCircle />}
                                title='Add Widgets'
                            />
                            <IconBox
                                icon={<IconMaximize />}
                                title='Customize Content'
                            />
                            <IconBox
                                icon={<IconPaint />}
                                title='Set Your Branding'
                            />
                            <IconBox
                                icon={<IconSendSquare />}
                                title='Publish Live'
                            />
                        </div>
                        <StyledText
                            htmlTag={'h1'}
                            fontSize='24px'
                            fontWeight={700}
                            textColor={theme.colors.contentText}
                        >
                            How It Works
                        </StyledText>
                        <StyledText
                            htmlTag={'p'}
                            fontSize='16px'
                            fontWeight={400}
                            textColor={theme.CorporateTheme.colors.textSecondary}
                            style={{ lineHeight: '25px', marginTop: '6px', marginBottom: '20px' }}
                        >
                            Create and launch your website in just 4 simple steps. Get ready-made pages like Home and About, plus the freedom to add or design your own custom pages.
                        </StyledText>
                        <Button
                            theme={theme}
                            $variant='customize'
                            width='554px'
                            style={{ margin: '0 auto' }}
                            onClick={handleCreateNewWebsite}
                        >
                            Start Creating Website Now
                        </Button>
                    </SectionProcess>
                </div>

            </MainContent>

        </>
    )
}

export default BuilderLandingPage


const MainContent = styled.div<{ theme: any }>(({ theme }) => ({
    flexGrow: 1,
    backgroundColor: theme.colors.contentBackground,
    color: theme.colors.contentText,
    minWidth: '600px',
    overflow: 'auto',
    height: 'calc(100vh - 57px)',
}));

const SectionTop = styled.div`
    position: relative;
    text-align: center;
    & .bgImage {
        background-image: url(${backgroundImage});
        text-align: center;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        padding: 40px 0px;
        height: 160px;
        margin-top: -60px;
        position: relative;
        box-shadow: 0 -3px 15px -7px rgba(255, 255, 255, 1);
        border-radius: 10px;
        // border: 1.14px solid transparent;
        // border-image-source: linear-gradient(180deg, #C9DFFF 43.78%, #FFFFFF 100%);
        // border-image-slice: 1;

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(180deg, #C9DFFF 43.78%, #FFFFFF 100%);
            border-radius: inherit;
            padding: 1.14px;
            -webkit-mask: 
                linear-gradient(#fff 0 0) content-box, 
                linear-gradient(#fff 0 0);
            -webkit-mask-composite: destination-out;
            mask-composite: exclude;
        }
    }
    & .blurr-con {
        position: absolute;
        height: 20px;
        width: 400px;
        top: -10px;
        right: 26%;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 24.74%);
        z-index: 0;
        top: 49%;
    }
`;

const SectionProcess = styled.div<{ theme: any }>(({ theme }) => ({
    border: '1px solid',
    borderRadius: '20px',
    marginTop: '20px',
    padding: '30px 65px',
    textAlign: 'center',
}));

const HorizontalLine = styled.div`
    height: 1px;
    width: 100%;
    margin-bottom: 28px;
    position: absolute;
    z-index: 0;
`;